import { useEffectOnce } from '@custom-react-hooks/use-effect-once';
import { Trans } from '@lingui/react/macro';

// We want to automatically refresh the page when the router fails to load a route.
//
// However, this could result in a refresh loop. So we'll
// put the last time we refreshed in local storage. If it was
// less than 10 seconds ago, something is wrong, so we'll just
// show this error page as-is. If we haven't refreshed in the
// last 10 seconds, we'll refresh the page and set local storage as needed.
export function NewVersionAvailable() {
  useEffectOnce(() => {
    const lastRefresh = localStorage.getItem('last-refresh');
    const now = Date.now();
    if (lastRefresh && now - Number(lastRefresh) < 10000) {
      return;
    }
    localStorage.setItem('last-refresh', String(now));
    window.location.reload();
  });
  return (
    <div style={{ padding: 100 }}>
      <h1 className="text-2xl font-bold">
        <Trans>A new version of ProfAI is available.</Trans>
      </h1>
      <p className="text-lg">
        <Trans>Please refresh the page to apply the changes and continue.</Trans>
      </p>
    </div>
  );
}
